import { useContext, useEffect, useState } from "react";
import { CommonContext } from "../../app/context/CommonContext";
import { Button, Flex, Tooltip, Typography } from "antd";
import { SvgIcon } from "../../../shared/icons";
import "./index.less";
import { fullUserSelector, idArrExpectedToSee, teamSelector, userSelector } from "src/store/user";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../Loader";
import { ViewModal } from "src/components/layout/ui/ViewModal";
import { initiateAndGetAllUserInfo } from "src/store/user/asyncRequests";

export const ViewingProcess = () => {
  // const { setCurrentView, setIsViewingProcess } = useContext(CommonContext);

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setIsViewingProcess(false);
  //   }, 10000);

  //   return () => clearTimeout(timer);
  // }, []);

  const [isViewModalOpened, setIsViewModalOpened] = useState(false);
  const showViewModal = () => {
    setIsViewModalOpened(true);
  };
  const closeViewModal = () => {
    setIsViewModalOpened(false);
  };

  // const test = useSelector(teamSelector);
  // console.log(test,'');
  const { clientWithTeam, hasTeam } = useSelector(teamSelector);
  const pageInfo = clientWithTeam?.pageInfo;
  const dispatch = useDispatch();

  const handleBackToMyViewClick = () => {
    const teamIdArr = [cliId];
    dispatch(idArrExpectedToSee(teamIdArr));
    dispatch(initiateAndGetAllUserInfo({ tz: Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone, teamIdArr }));
    closeViewModal();
  };

  const { idArrExpToSee, idArrLoadedUp, user } = useSelector(fullUserSelector);
  const { id: cliId } = useSelector(userSelector);
  const [teamViewing, setTeamViewing] = useState([]);
  useEffect(() => {
    const options = [];
    const teamCanLookAt = [...(pageInfo?.data?.team_members?.filter((tm) => tm?.id !== cliId) || [])];
    const teamMembers = teamCanLookAt
      ?.map((tm, i) => {
        const cliInIt = idArrExpToSee?.includes(user?.id);
        if (!idArrExpToSee?.includes(tm?.id)) {
          return null;
        }

        return (
          <>
            <b> {i + (cliInIt ? 2 : 1)}. </b> {tm?.first_name?.charAt(0)?.toUpperCase() + tm?.first_name?.slice(1).toLowerCase()}{" "}
            {tm?.last_name?.charAt(0)?.toUpperCase() + tm?.last_name?.slice(1).toLowerCase()} - {tm?.email}
            <br />
          </>
        );
      })
      .filter(Boolean);
    options.push(...(teamMembers || []));
    setTeamViewing(options);
  }, [idArrExpToSee, pageInfo?.data?.team_members]);

  return (
    <>
      {" "}
      {idArrExpToSee?.every((id) => id === user?.id) ? (
        ""
      ) : (
        <Flex vertical={true} className={"viewing-process-wrapper"}>
          <Flex className={"viewing-process-box"} gap={16} align={"center"}>
            <Flex gap={8} align={"center"}>
              <Tooltip
                title={
                  <>
                    <b> Viewing:</b>
                    <br />
                    {idArrExpToSee?.includes(user?.id) ? (
                      <>
                        {" "}
                        <b>1. </b> Your own account - {user?.email}
                        <br />
                      </>
                    ) : (
                      ""
                    )}
                    {teamViewing}
                  </>
                }
                placement="bottom"
              >
                {" "}
                <Typography.Paragraph className={"viewing-process-title"}>
                  {teamViewing?.length ? (
                    <>
                      {" "}
                      Viewing{idArrExpToSee?.includes(user?.id) ? " You &" : ""} {teamViewing?.length} Team Member{teamViewing?.length > 1 ? "s" : ""}
                    </>
                  ) : (
                    "Loading..."
                  )}
                </Typography.Paragraph>
              </Tooltip>
              <Typography.Paragraph
                className={"viewing-process-title"}
                style={{ textDecoration: "underline", color: "white", cursor: "pointer" }}
                onClick={showViewModal}
              >
                Edit
              </Typography.Paragraph>
              {/* <SvgIcon type={"arrowDown"} className={"arrow-down"} width={16} height={16} /> */}
            </Flex>
            <Button className={"back-to-my-view"} onClick={handleBackToMyViewClick}>
              Back to my View
            </Button>
          </Flex>
        </Flex>
      )}
      {/* */}
      {JSON.stringify([...idArrExpToSee].sort((a, b) => a - b)) === JSON.stringify([...idArrLoadedUp].sort((a, b) => a - b)) ? (
        ""
      ) : (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(211, 211, 211, 0.8)",
            zIndex: 9997, //dont change
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            pointerEvents: "auto",
          }}
        >
          <Flex vertical={true} gap={16} align={"center"} justify={"center"}>
            <div> Loading {idArrExpToSee?.every((id) => id === user?.id) ? "Your" : "Team"} Info </div>
            <br />
            <Loader
              style={{
                zIndex: 9998, //dont change
              }}
              size="large"
            />{" "}
          </Flex>
        </div>
      )}
      <ViewModal open={isViewModalOpened} onClose={closeViewModal} />
    </>
  );
};
